import { render, staticRenderFns } from "./myResources.vue?vue&type=template&id=d8853d6a&scoped=true"
import script from "./myResources.vue?vue&type=script&lang=js"
export * from "./myResources.vue?vue&type=script&lang=js"
import style0 from "./myResources.vue?vue&type=style&index=0&id=d8853d6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8853d6a",
  null
  
)

export default component.exports